
import React from 'react';
import { useTranslation } from 'react-i18next';
import CostEstimator from '@/components/CostEstimator';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const Index = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      {/* Header with Logo */}
      <div className="w-full p-4 bg-white shadow-sm">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <img 
            src="./lovable-uploads/834b5736-c59b-4cee-961c-1d5687a820fd.png" 
            alt={t('logo_alt')} 
            className="h-10" 
          />
          <LanguageSwitcher />
        </div>
      </div>

      {/* Calculator Section */}
      <section className="py-6">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">{t('calculator_title')}</h2>
              <p className="text-muted-foreground">
                {t('calculator_subtitle')}
              </p>
            </div>
            
            <CostEstimator />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-4 text-center text-sm text-muted-foreground">
        <div className="container mx-auto px-4">
          <p>{t('footer_copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
